"use client";

import React from "react";
import Image from "next/image";
import { Box, styled } from "@mui/material";
import { AdConfig } from "@/app/layout/useAdManager";
import { TrackedLink } from "./TrackedLink";

interface AdModuleProps {
  config: AdConfig;
}

const AdElement = styled(Box, {
  shouldForwardProp: (prop) => {
    return prop !== "isSelected";
  },
})<AdModuleProps>(({ theme, config }) =>
  theme.unstable_sx({
    textAlign: "center",
    backgroundColor: config.noBackground ? "transparent" : "grey.100",
    img: {
      maxWidth: "100%",
      height: "auto",
    },
    minWidth: config.width + "px",
    minHeight: config.height + "px",
  }),
);

const AdContainer = styled(Box, {
  shouldForwardProp: (prop) => {
    return prop !== "isSelected";
  },
})<AdModuleProps>(({ theme, config }) =>
  theme.unstable_sx({
    backgroundColor: config.noBackground ? "transparent" : "grey.100",
    padding: config?.noPadding ? 0 : 2,
    ...(config.minWidth
      ? {
          [`@media (max-width: ${config.minWidth}px)`]: {
            display: "none",
          },
        }
      : {}),
  }),
);

function AdModule({ config }: { config: AdConfig }) {
  return (
    <AdContainer config={config}>
      <AdElement config={config} id={config.elementId}>
        {config.static && (
          <TrackedLink href={config.static.href}>
            {config.static.images.map((image) => (
              <Box
                key={image.src.src}
                component={Image}
                src={image.src}
                alt={config.static?.alt || ""}
                sx={(theme) => ({
                  display: "none",
                  [theme.breakpoints.between(image.minWidth, image.maxWidth)]: {
                    display: "block",
                  },
                  margin: "0 auto",
                })}
              />
            ))}
          </TrackedLink>
        )}
      </AdElement>
    </AdContainer>
  );
}

export default AdModule;
